import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { map as _map } from 'lodash';

import NavigationItem from './NavigationItem/NavigationItem';

import {
  HeaderMobileContainer,
  HeaderMobileInnerContainer,
  LogoContainer,
  LogoLink,
  LogoImage,
  NavigationMenuContainer,
  NavigationHeaderContainer,
  NavigationHeaderInnerContainer,
  NavigationContainer,
  Navigation,
  CtaContainer,
  CtaInnerContainer,
  ButtonContainer,
  ApplyButton,
  BookATourButton,
  OpenCloseButtonContainer,
  OpenMenuButton,
  CloseMenuButton,
} from './HeaderMobile.css.js';

class HeaderMobile extends Component {
  state = {
    subNavigationItems: [],
    navigationMenuOpen: false,
  }

  renderLogo() {
    return (
      <LogoContainer>
        <LogoLink
          href={`/`}
        >
          <LogoImage
            src={`/images/ce-montessori/logos/ce-montessori-logo-horizontal-white-text.png`}
            alt={`c'e Montessori Logo`}
          />
        </LogoLink>
      </LogoContainer>
    );
  }

  renderNavigationItems(navigationItems) {
    return (
      _map(navigationItems, (navigationItem, index) => {
        // if (!!navigationItem.subNavigationItems) {
        //   debugger;
        //   console.log(`>>>>>> TESTING >>>>>>>>>>>>`);
        //   console.log(navigationItem.subNavigationItems);
        // }

        return (
          <NavigationItem
            key={index}
            config={{ showDropdownIcon: true }}
            content={{
              ...navigationItem
            }}
          />
        );
      }
      )
    );
  }

  renderNavigation() {
    const { navigationItems } = this.props.content;
    const { showLogo } = this.props.config;

    return (
      <NavigationMenuContainer
        visible={this.state.navigationMenuOpen}
      >
        <NavigationHeaderContainer>
          <NavigationHeaderInnerContainer>
            <OpenCloseButtonContainer>
              <a onClick={(e) => { this.setState({ navigationMenuOpen: false }) }}>
                <CloseMenuButton
                  config={{
                    color: `white`,
                    height: `25px`,
                  }}
                  content={{
                    title: `Close Navigation Menu Icon`,
                    type: `cancel`,
                  }}
                />
              </a>
            </OpenCloseButtonContainer>

            {showLogo ? this.renderLogo() : <span></span>}
          </NavigationHeaderInnerContainer>
        </NavigationHeaderContainer>

        <NavigationContainer>
          <Navigation role={`navigation`}>
            {this.renderNavigationItems(navigationItems)}
          </Navigation>

          {this.renderCtaContainer()}
        </NavigationContainer>
      </NavigationMenuContainer>
    );
  }

  renderCtaContainer() {
    return (
      <CtaContainer>
        <CtaInnerContainer>
          <ButtonContainer>
            <ApplyButton
              href={`/application`}
            >
              Apply Now
            </ApplyButton>

            <BookATourButton
              href={`/tours`}
            >
              Book a Tour
            </BookATourButton>
          </ButtonContainer>
        </CtaInnerContainer>
      </CtaContainer>
    );
  }

  render() {
    const { showLogo } = this.props.config;

    console.log(`>>>>>> this.state.navigationMenuOpen >>>>>>>>> ${this.state.navigationMenuOpen}`);

    return (
      <React.Fragment>
        {!this.state.navigationMenuOpen && (
          <HeaderMobileContainer>
            <HeaderMobileInnerContainer>
              <OpenCloseButtonContainer>
                <a onClick={(e) => { this.setState({ navigationMenuOpen: true }) }}>
                  <OpenMenuButton
                    config={{
                      color: `white`,
                      height: `25px`,
                    }}
                    content={{
                      title: `Open Navigation Menu Icon`,
                      type: `list-menu`,
                    }}
                  />
                </a>
              </OpenCloseButtonContainer>

              {showLogo ? this.renderLogo() : <span></span>}
            </HeaderMobileInnerContainer>
          </HeaderMobileContainer>
        )}
        
        {this.state.navigationMenuOpen && this.renderNavigation()}
      </React.Fragment>
    );
  }
}

HeaderMobile.propTypes = {
  config: PropTypes.shape({
    showLogo: PropTypes.bool,
  }),
  content: PropTypes.shape({
    navigationItems: PropTypes.arrayOf(
      PropTypes.shape({
        label: PropTypes.string.isRequired,
        link: PropTypes.string,
        subNavigationItems: PropTypes.arrayOf(
          PropTypes.shape({
            label: PropTypes.string.isRequired,
            link: PropTypes.string,
          }),
        ),
      })
    ).isRequired,
  }),
};

HeaderMobile.defaultProps = {
  config: {
    showLogo: true,
  },
};

export default HeaderMobile;